module.exports = __webpack_public_path__ + "src/assets/img/page6/46cbc635c3f9b001cb87613fd9167ef6.png";